import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UsersService } from '../../services/users.service'
import { Terminal, TerminalService } from '../../services/terminal.service'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { GlobalsService } from '../../services/globals.service'
import { OmsService } from '../../services/oms.service'
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common'
import { Router } from '@angular/router';
import * as jq from 'jquery';
declare let $: any;

@Component({
	selector: 'app-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
	user: any = [];
	userForm: UntypedFormGroup;
	userdetails: any = [];
	locations: any = [];
	favorites: any = [];
	formEditAllowed = [
		'userid',
		'password',
		'realname',
		'phone',
		'email',
		'defaultlocation',
		'fullaccess',
		'cancreatetender',
		'editinv',
		'dispatchadmin',
		'customeradmin',
		//'phoneno',
	]
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	color = 'blue'

	company_devices: any = false;
	user_devices: any = false;
	company_terminals: any = [];
	user_terminals: any = [];
	selectedBatchTerminalId: any = null;
	pendingSyncCount = 0;
	pendingSyncLoading = false;
	pendingSyncError: string | null = null;
	batchResult: any = null;
	batchInProgress = false;
	dropevent: any = '';
	saveavailable: any = false;

	deviceTypes = ['INVOICE', 'CREDIT', 'PICK', 'RECEIPT', 'LABEL']
	deviceTestMsg: any = {};
	terminalTestMsg: any = {};
	selectedDeviceTypes: {
		[key: string]: string[]; // Key should be a combination of deviceID and machineName
	} = {};

	selectedPrintTypes: {
		[key: string]: string[]; // Key should be a combination of deviceID and machineName
	} = {};

	isPosUser = false;
	searchAvailableDevices = '';
	searchUserDevices = '';
	config: any;

	constructor(public usersService: UsersService, public globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public location: Location, public globalsService: GlobalsService,public router: Router, private terminalService: TerminalService, private omsService: OmsService) {

		this.color = this.globalSearchService.color


	}

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe((r) => {
			this.config = r
			if(this.config.env.package === 'tires'){
				this.deviceTypes.push('DISPATCH');
			}
		});

		
		this.usersService.isPosUser().subscribe((isPOS) => {
			if (isPOS) {
				this.isPosUser = true;
			}
		})
		this.globalSearchService.user.subscribe((result: any) => {

			this.user = result.user;

			this.usersService.getUser(this.user.userid).subscribe((r: any) => {
				this.userdetails = r
				const details = this.userdetails
				const controls = [];
				const formGroup: UntypedFormGroup = new UntypedFormGroup({});
				Object.keys(details).forEach(key => {
					if (this.formEditAllowed.includes(key)) {
						const value = (details[key]) ? details[key] : '';
						controls.push({ name: key, control: new UntypedFormControl(value, []) })
					}
				});
				controls.forEach(f => {
					formGroup.addControl(f.name, f.control, {})
				});
				formGroup.setControl('password', new UntypedFormControl(''));
				this.userForm = formGroup;
				this.userForm.get('userid')?.disable();
				const data = { userid: this.user.userid }
				this.usersService.getCompanyDevices(data).subscribe(cd => {
					this.company_devices = cd;
					this.user_devices = this.usersService.getPrintSettings(this.user.userid);
				});
				
				// Load terminals
				this.usersService.getCompanyTerminals(data).subscribe((terminals: any) => {
					this.company_terminals = terminals || [];
				});
				this.usersService.getUserTerminals({ userid: this.user.userid }).subscribe((terminals: any) => {
					this.user_terminals = terminals || [];
					if (this.user_terminals.length && !this.selectedBatchTerminalId) {
						this.selectedBatchTerminalId = this.user_terminals[0]?.terminal_id || null;
					}
					this.refreshPendingSync();
				});

			})
		});

		const window_width = $(window).width();
		const $sidebar = $('.sidebar');
		const $sidebar_responsive = $('body > .navbar-collapse');
		const $sidebar_img_container = $sidebar.find('.sidebar-background');

		jq('.badge').click(function() {

			const $full_page_background = jq('.full-page-background');

			jq(this).siblings().removeClass('active');
			jq(this).addClass('active');

			const new_color = $(this).data('color');

			if ($sidebar.length !== 0) {
				$sidebar.attr('data-color', new_color);
			}

			if ($sidebar_responsive.length != 0) {
				$sidebar_responsive.attr('data-color', new_color);
			}
		});

		this.globalsService.getFavorites().subscribe((faves: any) => {
			this.favorites = faves;
		});
	}

	changColor(new_color: any) {

		//localStorage.setItem('color', JSON.stringify(new_color))
		this.globalSearchService.setColor(new_color)
		this.globalSearchService.color = new_color;
		this.color = new_color;

		const $sidebar = $('.sidebar');
		const $sidebar_responsive = $('body > .navbar-collapse');
		const $navbar_responsive = $('.navbar-top');
		const $sidebar_img_container = $sidebar.find('.sidebar-background');

		const $cards = $('body > .card-header');


		if ($sidebar.length !== 0) {
			$sidebar.attr('data-color', new_color);
			$sidebar.attr('data-background-color', new_color);
			$navbar_responsive.attr('data-background-color', new_color);
		}

		if ($cards.length !== 0) {
			$cards.attr('data-color', new_color);
			$cards.attr('color', new_color);
		}

		if ($sidebar_responsive.length != 0) {
			$sidebar_responsive.attr('data-color', new_color);
			$sidebar_responsive.attr('data-background-color', new_color);
			$navbar_responsive.attr('data-background-color', new_color);
		}

	}

	getSelectedDeviceTypes(deviceID: string, machineName: string) {
		return this.selectedDeviceTypes[deviceID + '_' + machineName] || [];
	}


	
		
	updateDeviceTypes(deviceID: string, machineName: string, deviceTypes: string[]) {
		const selectedDevice = this.user_devices.find(device =>
			device.deviceID === deviceID && device.machineName === machineName
		);

		if (selectedDevice) {
			// Use the correct method to update device types based on deviceID and machineName

		}
	}


	updatePrintSettings(deviceID: string, machineName: string, deviceTypes: string[]) {
		const selectedDevice = this.user_devices.find(device =>
			device.deviceID === deviceID && device.machineName === machineName
		);

		if (selectedDevice) {
			this.usersService.setPrintSetting(
				this.user.userid,
				selectedDevice.machineUser,
				selectedDevice.machineName,
				deviceID,
				deviceTypes
			);
		}
	}




	addUserDevice(device: any) {
		const payload = {
			userid: this.user.userid,
			deviceid: device.device_id,
			machinename: device.machine_name // Include both device_id and machine_name
		};

		this.usersService.setPrintSetting(
			this.user.userid,
			device.machine_user,
			device.machine_name,
			device.device_id,
			this.selectedDeviceTypes[device.device_id + '_' + device.machine_name] // Use combined key
		);

		this.user_devices = this.usersService.getPrintSettings(this.user.userid);
	}

	removeUserDevice(device: any) {
		const payload = {
			userid: this.user.userid,
			deviceid: device.deviceID,
			machinename: device.machineName // Include both device_id and machine_name
		};

		this.usersService.deletePrintSetting(this.user.userid, device.deviceID, device.machineName);
		this.user_devices = this.usersService.getPrintSettings(this.user.userid);
	}

	// --- Job-type chips (Printers tab) ---------------------------------------
	availableDeviceKey(device: any) {
		return device.device_id + '_' + device.machine_name;
	}

	availableSelectedTypes(device: any): string[] {
		return this.selectedDeviceTypes[this.availableDeviceKey(device)] || [];
	}

	// Toggle a job type on an Available printer (staged before Add).
	toggleAvailableType(device: any, type: string) {
		const key = this.availableDeviceKey(device);
		const types = [...(this.selectedDeviceTypes[key] || [])];
		const i = types.indexOf(type);
		if (i >= 0) { types.splice(i, 1); } else { types.push(type); }
		this.selectedDeviceTypes[key] = types;
	}

	// Toggle a job type on an assigned printer and persist immediately.
	toggleUserType(device: any, type: string) {
		const types = Array.isArray(device.deviceTypes) ? [...device.deviceTypes] : [];
		const i = types.indexOf(type);
		if (i >= 0) { types.splice(i, 1); } else { types.push(type); }
		device.deviceTypes = types;
		this.updatePrintSettings(device.deviceID, device.machineName, types);
	}

	// Machine names assigned more than once — these double-print every job.
	duplicateUserMachineNames(): Set<string> {
		const counts: { [name: string]: number } = {};
		(this.user_devices || []).forEach((d: any) => {
			counts[d.machineName] = (counts[d.machineName] || 0) + 1;
		});
		return new Set(Object.keys(counts).filter(n => counts[n] > 1));
	}

	// Send a test page to a user device (prints assets/test-page.pdf on that machine/printer).
	async testPrinter(device: any) {
		const key = device.deviceID + '_' + device.machineName;
		this.deviceTestMsg[key] = 'Sending…';
		try {
			const resp = await fetch('assets/test-page.pdf');
			const buf = await resp.arrayBuffer();
			let binary = '';
			const bytes = new Uint8Array(buf);
			for (let i = 0; i < bytes.length; i++) { binary += String.fromCharCode(bytes[i]); }
			const base64 = btoa(binary);
			const printType = (device.deviceTypes && device.deviceTypes[0]) || 'RECEIPT';
			const payload = {
				data: {
					pdf: base64,
					devices: [{ deviceID: device.deviceID + ':' + device.machineName, printType }]
				},
				roomName: 'Printers'
			};
			await this.omsService.waitForSocketConnection();
			const socket = this.omsService.socket;
			if (!socket || !socket.connected) {
				this.deviceTestMsg[key] = 'Not connected';
				return;
			}
			socket.emit('printPdf', payload, () => {});
			this.deviceTestMsg[key] = '✓ Test page sent';
		} catch (e) {
			this.deviceTestMsg[key] = 'Test failed';
		}
		setTimeout(() => { this.deviceTestMsg[key] = ''; }, 6000);
	}

	// Send a $0.01 test sale to a terminal (mirrors Print Connect's built-in terminal test).
	testTerminal(terminal: any) {
		const id = terminal.terminal_id;
		this.terminalTestMsg[id] = 'Testing…';
		this.terminalService.testTransaction(terminal).subscribe(
			() => {
				this.terminalTestMsg[id] = '✓ Test approved';
				setTimeout(() => { this.terminalTestMsg[id] = ''; }, 8000);
			},
			(err) => {
				this.terminalTestMsg[id] = 'Failed: ' + (err?.error?.message || 'error');
				setTimeout(() => { this.terminalTestMsg[id] = ''; }, 8000);
			}
		);
	}

	// Check if a device is already set up for a user
	isDeviceSetupForUser(deviceID: string) {
		const settings = JSON.parse(localStorage.getItem('printSettings')) || {};
		const userSettings = settings[this.user.userid] || [];
		return userSettings.some((device: any) => device.deviceID === deviceID);
	}

	// Terminal Methods
	getAvailableTerminals() {
		return (this.company_terminals || []).filter(terminal => 
			!this.user_terminals.some(ut => ut.terminal_id === terminal.terminal_id)
		);
	}

	addUserTerminal(terminal: any) {
		const data = {
			userid: this.user.userid,
			terminal_id: terminal.terminal_id
		};
		this.usersService.saveUserTerminal(data).subscribe(() => {
			this.user_terminals = [...this.user_terminals, terminal];
			this.showNotification('Terminal added', 'success', 'bottom', 'right');
		});
	}

	removeUserTerminal(terminal: any) {
		const data = {
			userid: this.user.userid,
			terminal_id: terminal.terminal_id
		};
		this.usersService.removeUserTerminal(data).subscribe(() => {
			this.user_terminals = this.user_terminals.filter(t => t.terminal_id !== terminal.terminal_id);
			this.showNotification('Terminal removed', 'success', 'bottom', 'right');
		});
	}

	refreshCompanyTerminals() {
		const data = { userid: this.user.userid };
		this.usersService.getCompanyTerminals(data).subscribe((terminals: any) => {
			this.company_terminals = terminals || [];
			this.showNotification('Terminals refreshed', 'success', 'bottom', 'right');
		});
	}

	refreshCompanyDevices() {
		const data = { userid: this.user.userid };
		this.usersService.getCompanyDevices(data).subscribe((cd: any) => {
			this.company_devices = cd;
			this.user_devices = this.usersService.getPrintSettings(this.user.userid);
			this.showNotification('Printers refreshed', 'success', 'bottom', 'right');
		});
	}

	editingTerminalId: string | null = null;
	editTerminalName = '';
	editMachineName = '';
	editMachineUser = '';

	startEditTerminal(terminal: any) {
		this.editingTerminalId = terminal.terminal_id;
		this.editTerminalName = terminal.terminal_name || '';
		this.editMachineName = terminal.machine_name || '';
		this.editMachineUser = terminal.machine_user || '';
	}

	cancelTerminalEdit() {
		this.editingTerminalId = null;
	}

	saveTerminalEdit() {
		if (!this.editingTerminalId) return;
		this.usersService.updateTerminal({
			terminal_id: this.editingTerminalId,
			terminal_name: this.editTerminalName || undefined,
			machine_name: this.editMachineName || undefined,
			machine_user: this.editMachineUser || undefined
		}).subscribe(() => {
			this.editingTerminalId = null;
			this.usersService.getCompanyTerminals({ userid: this.user.userid }).subscribe((terminals: any) => {
				this.company_terminals = terminals || [];
			});
			this.usersService.getUserTerminals({ userid: this.user.userid }).subscribe((terminals: any) => {
				this.user_terminals = terminals || [];
			});
			this.showNotification('Terminal updated', 'success', 'bottom', 'right');
		});
	}

	private getSelectedBatchTerminal(): Terminal | null {
		return (this.user_terminals || []).find((t: any) => String(t.terminal_id) === String(this.selectedBatchTerminalId)) || null;
	}

	onBatchTerminalChange() {
		this.refreshPendingSync();
	}

	refreshPendingSync() {
		const terminal = this.getSelectedBatchTerminal();
		if (!terminal) return;
		this.pendingSyncLoading = true;
		this.pendingSyncError = null;
		this.terminalService.getPendingSyncStatus(terminal).subscribe(
			(res: any) => {
				this.pendingSyncCount = res.count || 0;
				this.pendingSyncLoading = false;
			},
			(err) => {
				this.pendingSyncError = err?.error?.message || 'Failed to load sync status';
				this.pendingSyncLoading = false;
			}
		);
	}

	retryPendingSync() {
		const terminal = this.getSelectedBatchTerminal();
		if (!terminal) return;
		this.pendingSyncLoading = true;
		this.terminalService.retryPendingSync(terminal).subscribe(
			() => {
				this.pendingSyncLoading = false;
				this.refreshPendingSync();
			},
			(err) => {
				this.pendingSyncError = err?.error?.message || 'Retry failed';
				this.pendingSyncLoading = false;
			}
		);
	}

	runBatchSubtotal() {
		const terminal = this.getSelectedBatchTerminal();
		if (!terminal || this.batchInProgress) return;
		this.batchInProgress = true;
		this.batchResult = null;
		this.terminalService.batchSubtotal(terminal).subscribe(
			(res: any) => {
				this.batchResult = res?.result || res;
				this.batchInProgress = false;
			},
			(err) => {
				this.batchResult = { error: err?.error?.message || 'Batch subtotal failed' };
				this.batchInProgress = false;
			}
		);
	}

	runBatchClose() {
		const terminal = this.getSelectedBatchTerminal();
		if (!terminal || this.batchInProgress) return;
		if (!confirm('Run batch close for this terminal?')) return;
		this.batchInProgress = true;
		this.batchResult = null;
		this.terminalService.batchClose(terminal).subscribe(
			(res: any) => {
				this.batchResult = res?.result || res;
				this.batchInProgress = false;
			},
			(err) => {
				this.batchResult = { error: err?.error?.message || 'Batch close failed' };
				this.batchInProgress = false;
			}
		);
	}

	back(): void {
		this.location.back()
	}

	updateUser() {

		this.usersService.updateUser(this.userdetails.userid, this.userForm.getRawValue()).subscribe((results) => {
			this.user.user = results;
			//	this.globalSearchService.user.next(this.user);
			//	localStorage.setItem('user', JSON.stringify(this.user))

			this.showNotification('Updated', 'success', 'bottom', 'right');
		});

	}

	filteredAvailableDevices() {
		return (this.company_devices || []).filter(device =>
			(
				(device.machine_name?.toLowerCase().includes(this.searchAvailableDevices?.toLowerCase() || '') ||
				device.device_id?.toLowerCase().includes(this.searchAvailableDevices?.toLowerCase() || ''))
			) && !this.user_devices.some(userDevice =>
				userDevice.deviceID === device.device_id && userDevice.machineName === device.machine_name
			)
		);
	}


	filteredUserDevices() {
		return (this.user_devices || []).filter(device =>
			(
				device.machineName?.toLowerCase().includes(this.searchUserDevices?.toLowerCase() || '') ||
				device.deviceID?.toLowerCase().includes(this.searchUserDevices?.toLowerCase() || '')
			)
		);
	}

	ngAfterViewInit() {
		this.globalsService.getLocations().subscribe(details => {
			this.locations = details;
		});
	}
	drop(event: CdkDragDrop < any[] > ) {
		moveItemInArray(this.favorites, event.previousIndex, event.currentIndex);
		this.saveavailable = true;
	}
	
	removeFavorites(faveid){

		const data = { faveid: faveid };
		this.globalsService.removeFavorite(data).subscribe((faves: any) => {
			this.favorites = faves;
			this.saveavailable = true;
		});
		
	}
	reorderFavorites(){
		this.saveavailable = false;
		const data = { favorites: this.favorites };
		this.globalsService.reorderFavorites(data).subscribe((faves: any) => {
			this.router.navigate(['/']);
		});
	}
	showNotification(message, type, from, align) {
		//  const type = ['','info','success','warning','danger'];
		// const color = Math.floor((Math.random() * 4) + 1);

		$.notify({
			icon: 'notifications',
			message: message

		}, {
			type: type,
			timer: 2500,
			placement: {
				from: from,
				align: align
			},
			template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
				'<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
				'<i class="material-icons" data-notify="icon">notifications</i> ' +
				'<span data-notify="title">{1}</span> ' +
				'<span data-notify="message">{2}</span>' +
				'<div class="progress" data-notify="progressbar">' +
				'<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
				'</div>' +
				'<a href="{3}" target="{4}" data-notify="url"></a>' +
				'</div>'
		});
	}
}